import router from '@/router/index.js';

// Exposes the router singleton on the store so Vuex actions can navigate
// without importing the router module directly. Matches the pattern used by
// HttpClientVuexPlugin (`store.$http`) and AuthVuexPlugin (`store.$auth`).
// Consumer: `auth/logout` calls `useLogoutRedirect(store.$router)` after
// reset — see DEVUL-7821.
export const RouterVuexPlugin = store => {
  store.$router = router;
};
